import React, { forwardRef } from 'react';
import * as Styles from './styles';
import Text from '../../../Text';
export const Title = forwardRef((_ref, ref) => {
  let {
    children,
    adUrl,
    adUrlTarget,
    mode,
    titleID
  } = _ref;
  return React.createElement(Styles.Link, {
    className: mode,
    "data-ds-component": "DS-NewAdCard-Link",
    href: adUrl,
    target: adUrlTarget,
    ref: ref,
    tabIndex: -1,
    id: titleID
  }, React.createElement(Text.TitleSmall, {
    className: "".concat(mode, " title"),
    tag: "h2"
  }, children));
});
Title.displayName = 'Title';